/**
 * Check if a value is a simple object
 * @param {*} o Data to check
 * @returns {boolean} True if simple object
 */
export const isObject = o => Object.prototype.toString.call(o) === '[object Object]';
